import React from "react";
import BaseCircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  circularProgress: {
    position: "absolute",
    left: "calc(50% - 40px)",
    top: "calc(50% - 40px)",
  },
  hide: {
    display: "none",
  },
}));

const CircularProgress = ({ isLoaded }) => {
  const { classes, cx } = useStyles();
  return (
    <BaseCircularProgress
      className={cx(classes.circularProgress, {
        [classes.hide]: isLoaded,
      })}
      size="80px"
    />
  );
};

CircularProgress.propTypes = {
  isLoaded: PropTypes.bool,
};

export default CircularProgress;
